import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';


import { EMPTY, Subscription, map } from 'rxjs';
import { catchError } from 'rxjs/operators';


import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { WebsocketAwareNeptuneService } from 'app/Bootstrap/services/websocket-aware-neptune.service';


export enum NylasConnectionResultType {
    success,
    authError,
}

export interface NylasConnectionResult {
    resultType: NylasConnectionResultType;
    code?: string;
    state?: string;
}

@Component({
    selector: 'agpr-email-account-connector',
    templateUrl: './email-account-connector.component.html',
    styleUrls: ['./email-account-connector.component.scss'],
    standalone: false
})
export class EmailAccountConnectorComponent implements OnDestroy {
    static readonly MESSAGE_ID = 'EmailAccountConnector';

    loading: boolean = false;

    returnUrl: string;

    logoAltText = 'Agility PR Solutions';

    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly id = 'emailAccountConnector';

    private subscriptions: Subscription[] = [];
    private connection$ = this.activeRoute.queryParams.pipe(
        map(params => {
            if (params) {
                if (this.hasCodeAndState(params)) {
                    const code = params['code'];
                    const state = params['state'];

                    this.postMessage({
                        resultType: NylasConnectionResultType.success,
                        code: code,
                        state: state
                    });
                    window.close();

                    return EMPTY;
                }

                if (this.hasAuthError(params)) {
                    this.postMessage({
                        resultType: NylasConnectionResultType.authError
                    });
                    window.close();
                }
            }
            this.navigateToDash();
            return null;
        }),
        catchError((err) => {
            this.postMessage({
                resultType: NylasConnectionResultType.authError
            });
            window.close();
            return null;
        }),
    );

    constructor(
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private websocketAwareNeptuneService: WebsocketAwareNeptuneService,
    ) {
        this.subscriptions.push(
            this.connection$.subscribe()
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    private navigateToDash() {
        this.websocketAwareNeptuneService.connectToWebsocket(true);
        this.router.navigate(['Dashboard']);
    }

    private hasCodeAndState(params: Params): boolean {
        return params['code'] && params['state'];
    }

    private hasAuthError(params: Params): boolean {
        return params['error'] === 'access_denied' && params['error_subcode'] === 'cancel';
    }

    private postMessage(result: NylasConnectionResult) {
        const channel = new BroadcastChannel(EmailAccountConnectorComponent.MESSAGE_ID);
        channel.postMessage({
            key: EmailAccountConnectorComponent.MESSAGE_ID,
            result: result
        });
        channel.close();
    }
}
